import { get, post, patch, deleted } from "../index";
import OnholdRoutes from "./Onhold.routes";

const OnholdServices = {
  payToUser: async (obj) => {
    const result = await post(OnholdRoutes.payToUser, obj);
    return result;
  },

  getAll: async (page, limit, from, to) => {
    const result = await get(OnholdRoutes.getAll + `?page=${page}&limit=${limit}&from=${from}&to=${to}`);
    return result;
  },

  updateOnholdAd: async (id, obj) => {
    const result = await patch(OnholdRoutes.updateOnholdAd + `/${id}`, obj);
    return result;
  },

  deleteOnholdAd: async (id, obj) => {
    const result = await deleted(OnholdRoutes.deleteOnholdAd + `/${id}`);
    return result;
  },
};

export default OnholdServices;